
import { useState, useEffect } from 'react';

const testimonials = [
  {
    name: 'TJ Suchlandt',
    rating: 5,
    text: 'I have been coming here for 7 years and I have always had a fantastic experience! Everyone who works here is wonderful and genuinely loves their job. I never specifically ask for an aesthetician and they have all done great eyebrow threadings. Mina is absolutely the best, she is so fast, precise and makes you feel so welcome. She truly cares about her clients. Also it\'s very reasonably priced!'
  },
  {
    name: 'Nick Belgrave',
    rating: 5,
    text: 'I don\'t usually write reviews however I feel the basis for this review is warranted. Forever Young has nice classy decor and friendly staff. I highly recommend the hairstylist Jenna, as she\'s very knowledgeable, courteous, and did an excellent job cutting my hair. I\'m definitely going to keep going to Forever Young to get my haircut from her from now on.'
  },
  {
    name: 'Mimi O',
    rating: 5,
    text: 'Got my ombré powder done by Rubie. What an amazing investment, and experience from the moment I walked in to the moment I walked out. Thank you again Rubie and forever young spa for being so kind and taking the time out to make sure I am happy and well. I am so in love with my new brows. If you want to take your eyebrows to the next level this is the place to go.'
  },
  {
    name: 'Aurora Laverty',
    rating: 5,
    text: 'The atmosphere was so relaxing and calming, and everything was designed so beautifully! I felt like I was in a place that I couldn\'t afford to be in, so I checked the prices, and they were better prices then most places I have been. The staff were extremely friendly and welcoming, and they did amazing work with my threading. I will continue to give them my business for as long as I live in this city, I will even travel into the city just to come here, if I end up moving to a near by town.'
  }
];

export default function TestimonialsSection() {
  const [currentIndex, setCurrentIndex] = useState(0);
  const [isAnimating, setIsAnimating] = useState(false);

  useEffect(() => {
    const interval = setInterval(() => {
      setIsAnimating(true);
      setTimeout(() => {
        setCurrentIndex((prev) => (prev + 1) % testimonials.length);
        setIsAnimating(false);
      }, 300);
    }, 5000);
    return () => clearInterval(interval);
  }, []);

  const handleDotClick = (index: number) => {
    if (index !== currentIndex) {
      setIsAnimating(true);
      setTimeout(() => {
        setCurrentIndex(index);
        setIsAnimating(false);
      }, 300);
    }
  };

  return (
    <section className="py-20 bg-white">
      <div className="max-w-4xl mx-auto px-6">
        <div className="text-center mb-16 animate-fade-in-up">
          <h2 className="text-4xl lg:text-5xl font-bold text-black font-serif mb-6 animate-slide-down">
            What Our Clients Say
          </h2>
        </div>
        
        <div className="relative bg-pink-50 rounded-lg p-8 md:p-12 transform hover:scale-105 transition-all duration-500 hover:shadow-lg">
          <div className={`text-center transition-all duration-500 ${isAnimating ? 'opacity-0 transform translate-y-4' : 'opacity-100 transform translate-y-0'}`}>
            <div className="flex justify-center mb-4">
              {[...Array(testimonials[currentIndex].rating)].map((_, i) => (
                <i 
                  key={i} 
                  className="ri-star-fill text-yellow-400 text-xl animate-bounce-star"
                  style={{ animationDelay: `${i * 100}ms` }}
                ></i>
              ))}
            </div>
            <blockquote className="text-xl md:text-2xl text-gray-700 mb-6 italic leading-relaxed animate-fade-in">
              "{testimonials[currentIndex].text}"
            </blockquote>
            <div className="w-16 h-px bg-black mx-auto mb-4 animate-expand"></div>
            <cite className="text-lg font-semibold text-black animate-fade-in delay-200">
              {testimonials[currentIndex].name}
            </cite>
          </div>
          
          {/* Navigation dots */}
          <div className="flex justify-center mt-8 space-x-2">
            {testimonials.map((_, index) => (
              <button
                key={index}
                onClick={() => handleDotClick(index)}
                className={`w-3 h-3 rounded-full transition-all duration-500 cursor-pointer transform hover:scale-125 ${
                  index === currentIndex 
                    ? 'bg-black animate-pulse-dot' 
                    : 'bg-gray-300 hover:bg-gray-400'
                }`}
              />
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
